import React, { useRef, useState } from 'react';
import cx from 'classnames';
import { useClientSize } from '../../../../utils/hooks/useClientSize.js';
import { Item } from './Item/index.js';
import styles from './index.module.scss.js';

const LiveLoad = ({
  className,
  style,
  maxHeight = "500px",
  maxWidth = "100%",
  duration = 500,
  gradient = false,
  itemMaxWidth,
  itemMaxHeight,
  direction = "vertical",
  children: childrenProp,
  gap = 10,
  animation = {
    "data-aos": "fade-left-sm",
    "data-aos-delay": 100,
    "data-aos-delay-step": 100,
    "data-aos-duration": 1e3
  },
  ...props
}) => {
  const ref = useRef(null);
  const bottomGradientRef = useRef(null);
  const rightGradientRef = useRef(null);
  let children = [];
  if (Array.isArray(childrenProp)) {
    children = childrenProp.flat(2);
  } else if (childrenProp) {
    children = [childrenProp];
  }
  const [initialKeys] = useState(children?.map((child) => child.key));
  const { clientHeight: layoutHeight, clientWidth: layoutWidth } = useClientSize(ref);
  const { clientHeight: bottomGradientHeight } = useClientSize(bottomGradientRef);
  const { clientWidth: rightGradientWidth } = useClientSize(rightGradientRef);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      ...props,
      ...animation,
      ref,
      className: cx(styles.box, className, {
        [styles[direction]]: !!direction
      }),
      style: {
        ...style,
        "--max-width": maxWidth,
        "--max-height": maxHeight
      }
    },
    [...children].reverse().map((child) => /* @__PURE__ */ React.createElement(
      Item,
      {
        "data-key": child.key,
        index: child.key,
        className: child?.props?.className,
        key: child.key,
        duration,
        isInitiallyVisible: initialKeys.includes(child.key),
        direction,
        itemMaxWidth,
        itemMaxHeight,
        gap
      },
      child
    )),
    gradient && direction === "vertical" && /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles.gradient, {
          [styles.visible]: layoutHeight > bottomGradientHeight * 2
        }),
        ref: bottomGradientRef
      }
    ),
    gradient && direction === "horizontal" && /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles.gradient, {
          [styles.visible]: layoutWidth > rightGradientWidth * 2
        }),
        ref: rightGradientRef
      }
    )
  );
};
LiveLoad.displayName = "LiveLoad";

export { LiveLoad };
//# sourceMappingURL=index.js.map
